import { render, staticRenderFns } from "./inventarioAdd.vue?vue&type=template&id=69be244b&scoped=true"
import script from "./inventarioAdd.vue?vue&type=script&lang=js"
export * from "./inventarioAdd.vue?vue&type=script&lang=js"
import style0 from "./inventarioAdd.vue?vue&type=style&index=0&id=69be244b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69be244b",
  null
  
)

export default component.exports